import { Check, Edit, Save } from '@mui/icons-material';
import { notificar, setEditToken } from '../../lib/seguridad';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography, selectClasses } from '@mui/material';
import React, { useState } from 'react'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const SolicitarEdicion = ({ empresa, editable, setEditable }) => {
    const [openRestore, setOpenRestore] = useState(false);
    const [open, setOpen] = useState(false);
    const [emailPublicador, setEmailPublicador] = useState(empresa.email_publicador);
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [openFinish, setOpenFinish] = useState(false);
    const navigate = useNavigate();

    const handleClose = () => {
        setEmail('');
        setToken('');
        setOpen(false);
        setOpenRestore(false);
    }

    const handleConfirm = async () => {
        // si se esta solicitando nuevo token
        if (openRestore) {
            // validar email ingresado
            if (email.trim() !== '') {
                // enviar token (funciona api)
                const body = new FormData;
                body.append("id", empresa.id);
                body.append("email", email.trim());
                body.append("isOrganismo", true);
                await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/enviar_token`, { method: 'POST', body: body })
                    .then(res => res.json())
                    .then((respuesta) => {
                        if (respuesta.status != "success") { notificar(respuesta); return; }
                        if (respuesta.status == "success") {
                            toast.success("¡Correcto! el token ha sido enviado a tu correo electrónico.");
                            setOpenRestore(false);
                        }
                    })
            } else {
                toast.error("Correo electrónico incorrecto.");
            }
        } else {
            // validar token de edicion
            const body = new FormData;
            body.append("id", empresa.id);
            body.append("token", token);
            body.append("isOrganismo", 1);
            await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/validar_token`, { method: 'POST', body: body })
                .then((res) => res.json())
                .then((respuesta) => {
                    notificar(respuesta);
                    if (respuesta.status == 'success') {
                        setEditToken(empresa.id, token);
                        // abrir edicion de empresa ('/editar/token')
                        setOpen(false);
                        setEditable();
                        toast.success("Se habilitó la edición de campos.");
                    }
                });
        }
    }

    const handleFinish = () => {
        setOpenFinish(false);
        setEditable();
        window.location.reload();
    }
    return (
        <Box>
            {editable ?
                <Button color="success" startIcon={<Check />} onClick={() => setOpenFinish(true)}>Finalizar edición</Button>
                :
                <Button onClick={() => setOpen(true)} color="warning" startIcon={<Edit />}>Editar</Button>
            }
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Edición de empresa</DialogTitle>
                <DialogContent>
                    <Stack spacing={1}>
                        {openRestore
                            ?
                            (
                                <>
                                    <Typography>Para recuperar el token de edición, ingresa el correo que utilizaste al guardar la empresa ({emailPublicador.split('')[0] + "*****@" + emailPublicador.split("@")[1]}).</Typography>
                                    {/* Mostarar correo censurado (?)*/}
                                    <TextField value={email} onChange={(e) => setEmail(e.target.value)} name="email" label="Correo electrónico" />
                                </>
                            )
                            :
                            <>
                                <Typography>Para editar esta empresa, es necesario el token de validación</Typography>
                                <TextField value={token} onChange={(e) => setToken(e.target.value)} label="Token" name="token" />
                                <Typography>¿No tienes el token? <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => setOpenRestore(true)}>haz click aquí para recuperarlo</span></Typography>
                            </>
                        }
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="error" onClick={handleClose}>Cancelar</Button>
                    <Button variant="contained" color="success" onClick={handleConfirm}>Confirmar</Button>
                </DialogActions>
            </Dialog >
            <Dialog open={openFinish} onClose={() => setOpenFinish(false)}>
                <DialogTitle>Finalizar edición</DialogTitle>
                <DialogContent>
                    <Stack spacing={1}>
                        <Typography>Los cambios no guardados se <strong>perderán</strong>, ¿Desea continuar?</Typography>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="error" onClick={() => setOpenFinish(false)}>Cancelar</Button>
                    <Button variant="contained" color="success" onClick={handleFinish}>Continuar</Button>
                </DialogActions>
            </Dialog >
        </Box >
    )
}

export default SolicitarEdicion